class DupuisProWidget extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.launcher = this.querySelector('.dupuis-pro-widget__launcher');
    this.panel = this.querySelector('.dupuis-pro-widget__panel');

    this.launcher.addEventListener('click', () => this.toggle(!this.hasAttribute('open')), { signal });
    this.querySelector('.dupuis-pro-widget__close').addEventListener('click', () => this.toggle(false), { signal });
    this.querySelector('.dupuis-pro-widget__backdrop').addEventListener('click', () => this.toggle(false), { signal });

    document.addEventListener('click', (event) => {
      if (this.hasAttribute('open') && !this.contains(event.target)) this.toggle(false);
    }, { signal });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.hasAttribute('open')) return;
      this.toggle(false);
      this.launcher.focus();
    }, { signal });

    document.addEventListener('shopify:section:select', (event) => {
      if (this.closest(`#shopify-section-${event.detail.sectionId}`)) this.toggle(true);
    }, { signal });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (this.closest(`#shopify-section-${event.detail.sectionId}`)) this.toggle(false);
    }, { signal });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  toggle(open) {
    this.toggleAttribute('open', open);
    this.launcher.setAttribute('aria-expanded', open);
    this.panel.setAttribute('aria-hidden', !open);
    if (open) this.panel.focus({ preventScroll: true });
  }
}

if (!customElements.get('dupuis-pro-widget')) {
  customElements.define('dupuis-pro-widget', DupuisProWidget);
}
